<script setup lang="ts">
import { reactive, watch, ref } from 'vue'
import type { NewsData } from '~/composables/news/interface'
import { useNews } from '~/composables/news/use-news'
import { listCategory } from '~/resources/news'
import NewsItem from '~/components/common/news/news-item.vue'
import Pagination from '~common/pagination.vue'
import LoadingSpin from '~common/loading-spin.vue'
import NewsNoData from '~/components/desktop/pages/news/news-no-data.vue'

const props = defineProps({
  categorySlug: {
    type: String,
    default: ''
  }
})
const { fetchAllCategoryData, totalPost, postsPerPage, currentPage, handlePage, isLoading } = useNews()
const dataNews = reactive<NewsData[]>([])
const categoryName = ref('')
watch(
  () => props.categorySlug,
  value => {
    dataNews.splice(0)
    isLoading.value = true
    fetchAllCategoryData(dataNews, 0, postsPerPage.value, value)
    const currentCategory = listCategory.find(item => item.slug === props.categorySlug)
    categoryName.value = currentCategory?.name ? currentCategory.name.toLowerCase() : ''
  },
  { immediate: true }
)
</script>
<template>
  <div class="news-category__content">
    <div class="news-category__data">
      <div class="news-category__filter form-filter__select">
        <span class="text-title">{{ categoryName }}</span>
      </div>
      <LoadingSpin v-if="isLoading && !dataNews[0]?.data" />
      <div v-else-if="dataNews[0]?.data" class="news-list">
        <div v-for="item in dataNews[0]?.data" :key="item.slug">
          <NewsItem :item="item" :categoryName="dataNews[0]?.category?.name?.toLowerCase() ?? ''" />
        </div>
      </div>
      <NewsNoData v-else />
      <div v-if="totalPost > postsPerPage" class="pagination-news">
        <Pagination
          :total="totalPost"
          :page="currentPage"
          :itemPerPage="postsPerPage"
          :margin="1"
          :pageRange="4"
          :rangeIntervalPagBar="3"
          :reset="true"
          @changePage="handlePage($event, dataNews, categorySlug)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/pages/news/index.scss';
@import '~scssAsset/desktop/pages/news/news-category.scss';
</style>
